import { WixPatternsErrorCode } from './WixPatternsErrorCode';

export function isWixPatternsError(err: unknown): err is WixPatternsError {
  return err instanceof WixPatternsError;
}

export function isError(err: unknown): err is Error {
  return err instanceof Error;
}
export class WixPatternsError extends Error {
  public readonly originalException: unknown;
  public readonly extraData: Object | undefined;

  /**
   * This class is used to create a cairo error that occur within the application. It takes in an object with the following properties:
   * @param errorCode A WixPatternsErrorCode enum value representing the error that occurred.
   * @param originalException (optional) The exception that was thrown.
   * @param extraData (optional) Additional data related to the error.
   */
  constructor({
    errorCode,
    originalException,
    extraData,
  }: {
    errorCode: WixPatternsErrorCode;
    extraData?: Object;
    originalException?: unknown;
  }) {
    super(
      isError(originalException)
        ? originalException?.message || originalException?.name
        : '',
    );

    this.name = errorCode;
    this.originalException = originalException;
    this.extraData = extraData;
  }
}
